import {StyleForButton} from './Button.presents'
import { PropsType } from './Button.props'



export const Button = (props: PropsType) => {
  return <StyleForButton {...props}> {props.buttonText}</StyleForButton >
}